import { render, staticRenderFns } from "./EnvironmentPage.vue?vue&type=template&id=630a5252&scoped=true&"
import script from "./EnvironmentPage.vue?vue&type=script&lang=ts&"
export * from "./EnvironmentPage.vue?vue&type=script&lang=ts&"
import style0 from "./EnvironmentPage.vue?vue&type=style&index=0&id=630a5252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630a5252",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VDivider,VMain})
